import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { useFlags } from '@atlaskit/flag';
import CheckIcon from '@atlaskit/icon/core/check-mark';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';

const i18nFlags = defineMessages({
	successTitle: {
		id: 'team-admin-controls.flag.success.title',
		defaultMessage: 'Settings saved',
		description: 'Title for the success flag',
	},
	errorTitle: {
		id: 'team-admin-controls.flag.error.title',
		defaultMessage: 'Error',
		description: 'Title for the error flag',
	},
	errorDescription: {
		id: 'team-admin-controls.flag.error.description',
		defaultMessage: 'Something went wrong. Please try again.',
		description: 'Description for the error flag',
	},
});

export const useAdminControlsFlags = () => {
	const { showFlag } = useFlags();
	const { formatMessage } = useIntl();
	const showSuccessFlag = () => {
		void showFlag({
			id: `team-admin-controls-success-${Date.now()}`,
			title: formatMessage(i18nFlags.successTitle),
			isAutoDismiss: true,
			icon: <CheckIcon label={formatMessage(i18nFlags.successTitle)} />,
		});
	};

	const showErrorFlag = () => {
		void showFlag({
			id: `team-admin-controls-error-${Date.now()}`,
			title: formatMessage(i18nFlags.errorTitle),
			description: formatMessage(i18nFlags.errorDescription),
			isAutoDismiss: true,
			icon: <StatusErrorIcon label={formatMessage(i18nFlags.errorTitle)} />,
		});
	};
	return {
		showSuccessFlag,
		showErrorFlag,
	};
};
